import { render, staticRenderFns } from "./login.vue?vue&type=template&id=2ec876d0&scoped=true&"
import script from "./login.vue?vue&type=script&lang=js&"
export * from "./login.vue?vue&type=script&lang=js&"
import style0 from "./login.vue?vue&type=style&index=0&id=2ec876d0&prod&lang=css&"
import style1 from "./login.vue?vue&type=style&index=1&id=2ec876d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec876d0",
  null
  
)

export default component.exports